<template>
  <CreationsList />
</template>

<script>
import CreationsList from '~/components/myCreations/CreationsList.vue';

export default {
  name: 'MyCreations',
  components: {
    CreationsList,
  },
  setup() {
    return {};
  },
};
</script>
